__turbopack_context__.v({
  "carousel-wrapper": "style-module-scss-module__lBHuVa__carousel-wrapper",
  "charts": "style-module-scss-module__lBHuVa__charts",
  "component": "style-module-scss-module__lBHuVa__component",
  "favourite-toggle-experiment": "style-module-scss-module__lBHuVa__favourite-toggle-experiment",
  "left-section": "style-module-scss-module__lBHuVa__left-section",
  "listing-content": "style-module-scss-module__lBHuVa__listing-content",
  "map": "style-module-scss-module__lBHuVa__map",
  "market-stats": "style-module-scss-module__lBHuVa__market-stats",
  "price-history-placeholder": "style-module-scss-module__lBHuVa__price-history-placeholder",
  "request-info-section": "style-module-scss-module__lBHuVa__request-info-section",
  "request-info-section-lowered": "style-module-scss-module__lBHuVa__request-info-section-lowered",
  "skeleton": "style-module-scss-module__lBHuVa__skeleton",
  "smdc-tabs": "style-module-scss-module__lBHuVa__smdc-tabs",
  "title": "style-module-scss-module__lBHuVa__title",
});
